import { Producto } from 'app/models/producto.models';
import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Client } from 'app/models/client.models';
import { Caja } from 'app/models/caja.models';
import { AuditoriaService } from 'app/services/auditoria.service';
import { GeneralesService } from 'app/services/generales.service';
import { ProductoService } from 'app/services/producto.service';
import { ClientesService } from 'app/services/clientes.service';
import { ParametrosService } from 'app/services/parametros.service';
import { DialogoComponent } from '../dialogo/dialogo.component';
import { Stock } from 'app/models/stock.models';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { AperturaComponent } from './apertura/apertura.component';
import { CierreComponent } from './cierre/cierre.component';
import { DataService } from 'app/services/data.service';
import { ListaClienteCajaComponent } from './lista-cliente-caja/lista-cliente-caja.component';
import { CajaService } from 'app/services/caja.service';
import { ConfirmarCajaComponent } from './confirmar-caja/confirmar-caja.component';
import { OperacionCaja } from 'app/models/opercaja.models';
import { ListaprecioService } from 'app/services/listaprecio.service';
import { TcomprobanteService } from 'app/services/tcomprobante.service';
import { ListaProductosDialogoComponent } from '../lista-productos-dialogo/lista-productos-dialogo.component';
import * as dayjs from 'dayjs';
import { ComprobantesService } from 'app/services/comprobantes.service';
import { EditarCantidadesComponent } from './editar-cantidades/editar-cantidades.component';
import { LoadingComponent } from '../loading/loading.component';
import { VoucherTypes } from 'app/models/vouchertype.models';
import { CashBoxSession } from 'app/models/cashBoxSession.models';
import { PtoventaService } from 'app/services/ptoventa.service';
import { Voucher } from 'app/models/voucher.models';
import { Header } from 'app/models/header.models';
import { Concepts } from 'app/models/concept.models';
import { ListaFormasPagoComponent } from './lista-formas-pago/lista-formas-pago.component';
import { ProcesarDevolucionComponent } from './procesar-devolucion/procesar-devolucion.component';
import { ConfirmacionVentaComponent } from './confirmacion-venta/confirmacion-venta.component';
import { TicketImpresionService } from 'app/services/ticket-impresion.service';

@Component({
  selector: 'app-caja',
  templateUrl: './caja.component.html',
  styleUrls: ['./caja.component.css'],
})
export class CajaComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('inputcliente') clienteElement: ElementRef;
  @ViewChild('inputcantidad') cantidadElement: ElementRef;
  @ViewChild('inputarticulo') articuloElement: ElementRef;

  loading = false;
  searchingProduct = false; // Nueva propiedad para indicar búsqueda de producto
  articuloSel = '';
  cantidad = 0;
  lstarticulos: any[] = [];
  lstStock: any[] = [];
  selectedRow: number;
  unarticulo: Producto;
  unCliente: Client;
  total = 0.0;
  montoing = 0.0;
  cambio = 0.0;
  fecha;
  hora;
  verBtnCancelar;
  cajero = '';
  cliente = 'Consumidor Final';
  cajaActual: Caja;
  cashBox: Caja;
  cashBoxSession: CashBoxSession;
  clienteSel: string;
  setClickedRow: Function;
  fpago: any;
  verInputArticulo: boolean;
  verBtnBuscarArticulo: boolean;
  verBtnFPago: boolean;
  verBtnConfirmar: boolean;
  verInputBuscarCliente: boolean;
  VerBtnCerrarCaja: boolean;
  VerBtnAbrirCaja: boolean;
  verBtnBuscarCliente: boolean;
  lstPagos: any;
  lstDetalles = [];
  listaFormularioImprimir: any = [];
  observaciones: string;
  form: UntypedFormGroup;
  monedas = [];
  listaprecios = [];
  typeComprobante: VoucherTypes;
  comprobante: Voucher;
  cabecera: Header;
  concepto: Concepts;
  typeComprobanteDB;
  talonario;
  nro = 0;
  uid;
  dialogRefLoading;
  dialogRefConfirmacion;
  listaPrecio: number = 1;
  private lastVisibilityUpdate = 0; // Para controlar la frecuencia de actualizaciones
  private cajaDialogShown = false; // Para evitar que se abra múltiples veces el diálogo
  private isInitialLoad = true; // Para distinguir entre carga inicial y actualizaciones

  constructor(
    public cajaService: CajaService,
    private router: Router,
    private dataService: DataService,
    private servicioGrales: GeneralesService,
    private articuloService: ProductoService,
    private clienteService: ClientesService,
    private auditoriaService: AuditoriaService,
    private paramService: ParametrosService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: UntypedFormBuilder,
    private listaprecioService: ListaprecioService,
    private typeComprobService: TcomprobanteService,
    private comprobanteSerice: ComprobantesService,
    private parametroServicio: ParametrosService,
    private ticketImpresionService: TicketImpresionService,
  ) {
    moment.locale('es');
    this.form = this.fb.group({
      clienteSel: '',
      razonsocial: '',
      type: '',
      observaciones: '',
      moneda: 'Pesos',
      lista: 'sinseleccion',
    });
    this.setClickedRow = function (index) {
      this.selectedRow = index;
    };
  }

  ngOnInit() {
    const sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    if (sidebar !== undefined) {
      sidebar.innerHTML = 'Caja';
    }
    this.fecha = moment().format('L');
    this.hora = moment().format('LT');
    this.isCajaAbierta();
    this.uid = this.dataService.getUID();
    this.form.controls.clienteSel.setValue(this.cliente, {
      onlySelf: true,
    });
    this.getClienteById(1);
    this.getListaPrecios();
    this.getConceptos();
    this.getMonedas();
    this.obtenerMediosDePagoEfectivo();
    
    // Listener para actualizar datos cuando se regresa a la página
    document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    
    // Marcar que la carga inicial ha completado
    this.isInitialLoad = false;
  }

  ngOnDestroy() {
    // Remover el listener cuando se destruye el componente
    document.removeEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
    
    // Limpiar todas las variables del componente
    this.articuloSel = '';
    this.cantidad = 0;
    this.lstarticulos = [];
    this.lstStock = [];
    this.selectedRow = null;
    this.unarticulo = null;
    this.unCliente = null;
    this.total = 0.0;
    this.montoing = 0.0;
    this.cambio = 0.0;
    this.cajero = '';
    this.cliente = 'Consumidor Final';
    this.cajaActual = null;
    this.cashBox = null;
    this.cashBoxSession = null;
    this.clienteSel = null;
    this.fpago = null;
    this.lstPagos = null;
    this.lstDetalles = [];
    this.listaFormularioImprimir = [];
    this.observaciones = '';
    this.monedas = [];
    this.listaprecios = [];
    this.typeComprobante = null;
    this.comprobante = null;
    this.cabecera = null;
    this.concepto = null;
    this.typeComprobanteDB = null;
    this.talonario = null;
    this.nro = 0;
    this.loading = false;
    this.searchingProduct = false;
    this.lastVisibilityUpdate = 0;
    this.cajaDialogShown = false;
    this.isInitialLoad = true;
    
    // Cerrar diálogos si están abiertos
    if (this.dialogRefLoading) {
      this.dialogRefLoading.close();
      this.dialogRefLoading = null;
    }
    if (this.dialogRefConfirmacion) {
      this.dialogRefConfirmacion.close();
      this.dialogRefConfirmacion = null;
    }
    
    // Limpiar variables del servicio público
    this.cajaService.eliminarListaArticulos();
    this.cajaService.articulosList = [];
  }

  handleVisibilityChange() {
    // Cuando la página se vuelve visible (usuario regresa), actualizar datos
    if (!document.hidden) {
      const now = Date.now();
      // Solo actualizar si han pasado al menos 2 segundos desde la última actualización
      if (now - this.lastVisibilityUpdate > 2000) {
        this.lastVisibilityUpdate = now;
        // Pequeño delay para asegurar que la navegación se completó
        setTimeout(() => {
          this.actualizarDatosSinDialog();
        }, 300);
      }
    }
  }

  ngAfterViewInit() {
    this.setFocusArticulo();
  }

  getMonedas() {
    this.paramService.getMonedas().subscribe((data) => {
      this.monedas = data;
      let moneda = this.monedas.find(x => x.code === 'PES')
      this.form.controls.moneda.setValue(moneda?.id, {
        onlySelf: true
      })
      this.form.controls.moneda.disable();
    });
  }

  getClienteById(id) {
    this.clienteService.getClienteById(id).subscribe((data) => {
      this.unCliente = data;
    });
  }

  getClienteBytype(type) {
    this.clienteService.getClientesBytype(type).subscribe((data) => {
      this.unCliente = data;
    });
  }

  getListaPrecios() {
    this.listaprecioService.getListaPrecios().subscribe((data) => {
      this.listaprecios = data;
      this.form.controls.lista.setValue(this.listaprecios[0].id)
    });
  }

  getConceptos() {
    this.parametroServicio.getConceptos().subscribe((data) => {
      let conceptos = data;
      let indiceOtros = conceptos.findIndex(x => x.description?.toLowerCase().includes('otros'));
      conceptos.splice(indiceOtros, 1);
      this.concepto = conceptos.find(x => x.code === '1');
    })
  }

  openSnackBar(message: string, type) {
    this.snackBar.open(message, type, {
      duration: 5000,
      verticalPosition: 'top'
    });
  }

  obtenerMediosDePagoEfectivo() {
    this.paramService.getMediosPagos().subscribe(
      (data) => {
        // buscamos el medio de pago por nombre
        const mpagos = data.find((x) => x.name?.toLowerCase() === 'efectivo');
        if (mpagos !== undefined) {
          this.fpago = mpagos;
        }
        
      },
      (err) => {
        this.openSnackBar('Error al obtener medios de pago', 'Error');
      }
    );
  }

  isCajaAbierta() {
    this.servicioGrales.getCajaAbierta().subscribe(
      (data) => {
        if (data) {
          // CAJA ABIERTA - Habilitar todos los controles
          this.cajaActual = data.cashBox as Caja;
          this.cashBoxSession = data as CashBoxSession;
          this.talonario = data?.cashBox?.salesPoint?.name;
          // cajero con nombre y apellido
          this.cajero = data.user.name;
          // Habilitar todos los inputs y botones
          this.verInputBuscarCliente = false;
          this.verBtnBuscarCliente = false;
          this.verInputArticulo = true;
          this.verBtnBuscarArticulo = true;
          this.verBtnFPago = true;
          this.verBtnConfirmar = true;
          this.VerBtnCerrarCaja = true;
          this.VerBtnAbrirCaja = false;
          
          // Habilitar formularios
          this.form.enable();
        } else {
          // CAJA CERRADA - Deshabilitar todos los controles
          this.cajaActual = null;
          this.cashBoxSession = null;
          this.talonario = '';
          this.cajero = '';
          
          // Deshabilitar todos los inputs y botones excepto "Abrir Caja"
          this.verInputBuscarCliente = false;
          this.verBtnBuscarCliente = false;
          this.verInputArticulo = false;
          this.verBtnBuscarArticulo = false;
          this.verBtnFPago = false;
          this.verBtnConfirmar = false;
          this.VerBtnCerrarCaja = false;
          this.VerBtnAbrirCaja = true;
          
          // Deshabilitar formularios
          this.form.disable();
          
          // Solo abrir el diálogo automáticamente en la carga inicial del componente
          // No en actualizaciones posteriores por cambio de visibilidad o navegación
          if (!this.cajaDialogShown && this.isInitialLoad) {
            this.cajaDialogShown = true;
            this.openDialogAperturaCaja();
          }
        }
      },
      (err) => {
        this.openSnackBar('Error al verificar estado de caja', 'Error');
      }
    );
  }

  comprobarListaPrecio() {
    // Método para verificar lista de precios - log removido
  }

  /**
   * Getter para verificar si la caja está abierta
   * Útil para usar en el template
   */
  get isCajaOpen(): boolean {
    return this.cajaActual !== null && this.cajaActual !== undefined;
  }

  verListaClientes() {
    if (this.cajaActual !== undefined) {
      const dialogRef = this.dialog.open(ListaClienteCajaComponent, {
        width: '50%',
        minHeight: '200px',
        data: {
          type: 'cliente',
        },
        disableClose: true,
        autoFocus: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          this.unCliente = result;
          this.cajaService.eliminarListaArticulos();
          this.setFocusArticulo();
          this.form.controls.clienteSel.setValue(this.unCliente?.companyName, {
            onlySelf: true,
          });
        }
      });
    } else {
      Swal.fire(
        'Atención!',
        'Debe abrir la caja para poder continuar.',
        'warning'
      );
    }
  }

  verListaArticulos() {
    if (!this.cajaActual) {
      Swal.fire(
        'Atención!',
        'Debe abrir la caja para poder continuar.',
        'warning'
      );
      return
    }
    
    const dialogRef = this.dialog.open(ListaProductosDialogoComponent, {
      width: '60%',
      maxHeight: '85%',
      data: {
        type: 'articulo',
        bonificacion: this.unCliente?.bonificacionValue,
      },
      disableClose: true,
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.calcularTotal();
      this.verBtnFPago = false;
      this.verBtnConfirmar = false;
    });
  }

  verDialogoOk(borrar: boolean) {
    let formExiste = false;
    if (this.listaFormularioImprimir.length > 0) {
      formExiste = true;
    }
    const dialogRef = this.dialog.open(DialogoComponent, {
      width: '300px',
      data: {
        type: 'ok',
        formulario: formExiste,
      },
      disableClose: true,
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (borrar) {
          if (result) {
            const dialogRef2 = this.dialog.open(DialogoComponent, {
              width: '70%',
              height: '700px',
              data: {
                type: 'imprimirresumen',
                total: (this.total = result['total']),
                pagos: (this.lstPagos = result['pagos']),
                detalle: this.listaFormularioImprimir,
                sujeto: this.unCliente,
              },
              disableClose: true,
              autoFocus: true,
            });
            dialogRef2.afterClosed().subscribe((result) => {
              if (result !== undefined) {
                this.calcularTotal();
                this.auditoriaService
                  .guardarAuditoria(
                    '',
                    '',
                    'caja',
                    'imprimir resumen',
                    sessionStorage.getItem('userid'),
                    'imprimir'
                  )
                  .subscribe();
              }
            });
          } else {
            this.calcularTotal();
          }
        }
      },
      (err) => {
        this.openSnackBar('Error en el diálogo', 'Error');
      },
      () => {
        this.calcularTotal();
        this.cancelar();
      }
    );
  }

  // confirmamos la operacion
  verConfirmar() {
    if (this.VerBtnAbrirCaja) {
      Swal.fire('Abrir Caja!', 'Para continuar con la venta debe abrir la caja.', 'warning');
      return;
    }
    this.loading = true;
    const dialogRef = this.dialog.open(
      ListaFormasPagoComponent,
      {
        width: '50%',
        height: 'auto',
        data: { total: this.total },
        disableClose: true,
        autoFocus: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result && Array.isArray(result) && result.length > 0) {
        // Recibe el array de formas de pago
        this.lstPagos = result;
        this.openDialogLoading();
        this.guardarVenta();
      } else {
        this.loading = false;
      }
    });
  }

openDialogLoading() {
  this.dialogRefLoading = this.dialog.open(LoadingComponent, {
    data: {
      mensaje: 'Procesando la venta! Espere ...'
    },
    disableClose: true,
    autoFocus: true,
  });
}
  
  /**
   * Abre el dialogo para el proceso de cierre de caja
   *
   * @memberof CajaComponent
   */
  openDialogCierreCaja(): void {
    if (this.cajaActual !== undefined) {
      this.servicioGrales.getSumaMovientosByCajaSesion(this.cashBoxSession.id).subscribe(
        (data) => {
          const dialogRef = this.dialog.open(CierreComponent, {
            width: '50%',
            data: {
              cajaActual: this.cajaActual,
              cashSessionCloseData: data, // Nuevos datos dinámicos
            },
            disableClose: true,
            autoFocus: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result !== undefined) {
              Swal.fire(
                'Excelente!',
                'Se realizó el cierre de caja correctamente',
                'success'
              );
              // Actualizar todos los datos de la pantalla
              this.actualizarDatosPantalla();
            }
          });
        },
        (err) => {
          this.openSnackBar('Error al obtener movimientos de caja', 'Error');
        }
      );
    }
  }

  openDialogAperturaCaja(): void {
    const dialogRef = this.dialog.open(AperturaComponent, {
      width: '450px',
      disableClose: true,
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      // si el usuario acepto abrir la caja
      if (result !== undefined) {
        this.cajaActual = new Caja();
        this.cajaActual.initialBalance = Number(result.monto);
        this.cajaActual.salesPointId = Number(result.puntoventa);
        this.cajaActual.currentBalance = Number(result.monto);
        this.cajaActual.receiptBookId = Number(result.receiptBook);
        this.cajaActual.uid = this.uid;
        this.servicioGrales.guardarCaja(this.cajaActual).subscribe(
          (data) => {
            this.cajaActual.id = data.caja?.id;
            
            // Habilitar todos los controles después de abrir la caja
            this.verInputArticulo = true;
            this.verBtnBuscarArticulo = true;
            this.verBtnFPago = true;
            this.verBtnConfirmar = true;
            this.VerBtnCerrarCaja = true;
            this.VerBtnAbrirCaja = false;
            this.form.enable();
            
            Swal.fire(
              'Excelente!',
              'Ya se realizó la apertura de caja',
              'success'
            );
            // Actualizar todos los datos de la pantalla
            this.actualizarDatosPantalla();
          },
          (err) => {
            this.openSnackBar('Error al abrir la caja', 'Error');
          }
        );
      } else {
        // Si el usuario cancela, resetear el flag para que pueda abrir la caja manualmente después
        this.cajaDialogShown = false;
        // No llamar actualizarDatosPantalla aquí para evitar el bucle
        // Solo configurar los botones para mostrar la opción de abrir caja
        this.VerBtnCerrarCaja = false;
        this.VerBtnAbrirCaja = true;
        // Mantener controles deshabilitados
        this.verInputArticulo = false;
        this.verBtnBuscarArticulo = false;
        this.verBtnFPago = false;
        this.verBtnConfirmar = false;
        this.form.disable();
      }
    });
  }

  obtenerUnArticulo(idarticulo) {
    if (!this.cajaActual) {
      Swal.fire(
        'Atención!',
        'Debe abrir la caja para poder continuar.',
        'warning'
      );
      return
    }
    if (!idarticulo || idarticulo.trim() === '') {
      // No hacer nada si el campo está vacío, evitar abrir el menú de acciones
      return;
    } else {
      // Primero intentar buscar por código de barras, luego por código normal
      this.buscarArticuloPorCodigoBarras(idarticulo);
      // No limpiar aquí, se limpia en procesarArticuloEncontrado después de encontrar el producto
    }
  }

  // Método específico para manejar el evento Enter en el input de artículo
  onArticuloEnterPressed(event: KeyboardEvent) {
    event.preventDefault(); // Prevenir comportamiento por defecto
    event.stopPropagation(); // Evitar que el evento se propague
    
    const target = event.target as HTMLInputElement;
    const valor = target.value?.trim() || '';
    
    // Solo proceder si hay un valor en el input
    if (valor) {
      this.procesarBusquedaArticulo(valor);
    }
  }

  // Método específico para procesar la búsqueda de artículo desde el teclado
  procesarBusquedaArticulo(codigo: string) {
    if (!this.cajaActual) {
      Swal.fire(
        'Atención!',
        'Debe abrir la caja para poder continuar.',
        'warning'
      );
      return;
    }
    
    if (!codigo || codigo.trim() === '') {
      return;
    }
    
    // Buscar el artículo
    this.buscarArticuloPorCodigoBarras(codigo);
  }

  /*
    Recibo un id de articulo y busco el articulo completo en la base de datos
  */
  buscarArticulo(idarticulo, typetabla?: boolean) {
    if (idarticulo !== '') {
      this.searchingProduct = true;
      // obtengo el articulo
      this.articuloService.getArticuloPorcode(idarticulo).subscribe(
        (data) => {
          this.searchingProduct = false;
          const articulo = data as Producto;
          this.procesarArticuloEncontrado(articulo);
        },
        (err) => {
          this.searchingProduct = false;
          this.openSnackBar('No se encontró ningún producto con el código ingresado', 'Información');
          // Solo limpiar el campo cuando no se encuentra el producto
          this.limpiarCamposNuevoArticulo();
        }
      );
    }
  }

  verDialogoSinStock(nombre) {
    const dialogRef = this.dialog.open(DialogoComponent, {
      width: '450px',
      data: { type: 'sinstock', articuloNombre: nombre },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  obetenerStockById(idstock): Stock {
    let stockdb: Stock;
    this.articuloService.getStockById(idstock).subscribe(
      (data) => (stockdb = data as Stock),
      (err) => {
        this.openSnackBar('Error al obtener stock', 'Error');
      }
    );
    return stockdb;
  }

  buscarCliente(cliente: string) {
    if (this.cajaActual !== undefined) {
      if (cliente !== '') {
        this.clienteService.getClienteByNumero(cliente).subscribe(
          (data) => {
            this.unCliente = data;
            this.verInputArticulo = false;
            this.verBtnBuscarArticulo = false;
            this.form.controls.clienteSel.setValue(
              this.unCliente?.companyName,
              {
                onlySelf: true,
              }
            );
          },
          (err) => {
            this.openSnackBar('Error al buscar cliente', 'Error');
          },
          () => {
            this.setFocusArticulo();
          }
        );
      } else {
        this.clienteService.getClienteByNumero('1').subscribe(
          (data) => (this.unCliente = data),
          (err) => {
            this.openSnackBar('Error al obtener cliente por defecto', 'Error');
          },
          () => {
            if (this.unCliente !== undefined) {
              this.cliente = this.unCliente.companyName;
              this.clienteSel = '';
              this.verInputArticulo = false;
              this.verBtnBuscarArticulo = false;
            }
            this.setFocusArticulo();
          }
        );
      }
    } else {
      Swal.fire(
        'Atención!',
        'Debe abrir la caja para poder continuar.',
        'warning'
      );
    }
  }

  limpiarCamposNuevoArticulo() {
    if (this.articuloElement && this.articuloElement.nativeElement) {
      this.articuloElement.nativeElement.value = '';
    }
    this.setFocusArticulo();
  }

  cargarArticulo(articulo: any) {
    let stockdb;
    if (articulo !== undefined) {
    }
  }

  editarArticulo(articulo, indice?: number) {
    let bonificacion= this.unCliente.bonificacionValue;
    const dialogRef = this.dialog.open(EditarCantidadesComponent, {
      width: '450px',
      data: {
        articulo: articulo,
        unArticulo: articulo.articulo,
        indice,
        bonificacion,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.calcularTotal();
    });
  }

  comprobarArticuloCargado(id: number): boolean {
    let resul = false;
    for (let index = 0; index < this.cajaService.articulosList.length; index++) {
      const articulo = this.cajaService.articulosList[index];
      if (articulo.id === id) {
        resul = true;
        break;
      }
    }
    return resul;
  }

  comprobarIndiceArticuloCargado(id: number): number {
    let resul = -1;
    for (let index = 0; index < this.cajaService.articulosList.length; index++) {
      const articulo = this.cajaService.articulosList[index];
      if (articulo.id === id) {
        resul = index;
        break;
      }
    }
    return resul;
  }

  cambiarPrecioArticulo(articulo: Producto, preciounit): number {
    // calculamos los valores
    return this.servicioGrales.calcularCostoUnitario(
      preciounit,
      articulo.purchasePrice
    );
  }

  getArticuloTablaByIndice(code: string): any {
    let resul: any;
    for (let index = 0; index < this.lstarticulos.length; index++) {
      const articulo = this.lstarticulos[index];
      if (articulo.idstock === code) {
        resul = articulo;
        break;
      }
    }
    return resul;
  }

  guardarVenta() {
    // Verificar si hay formas de pago para procesar
    if (!this.lstPagos || (Array.isArray(this.lstPagos) && this.lstPagos.length === 0)) {
      this.loading = false;
      this.openSnackBar('No se han seleccionado formas de pago', 'Error');
      if (this.dialogRefLoading) {
        this.dialogRefLoading.close();
      }
      return;
    }
    
    // Proceder con el guardado de la venta
    this._guardarVentaConPagosYComprobanteCaja(this.lstPagos);
  }

  // Método privado para guardar la venta con pagos y comprobante de caja asociado
  private _guardarVentaConPagosYComprobanteCaja(pagos, comprobanteCajaId?) {
    // Parsear el array de pagos que viene de ListaFormasPago
    const pagosArray = Array.isArray(pagos) ? pagos : (pagos?.pagos || []);
    
    // Mapear los métodos de pago según el DTO PaymentMethodDto
    const paymentMethods = pagosArray.map(pago => {
      // Verificar si es un objeto formateado según la estructura del array que vemos en la imagen
      if (pago && pago.formaPago && typeof pago.formaPago === 'object') {
        return {
          paymentMethodId: Number(pago.formaPago.id || pago.formaPago.code || 0),
          amount: Number(pago.montorecibido || 0)
        };
      } 
      // Formato alternativo que podría venir
      return {
        paymentMethodId: Number(pago.paymentMethodId || pago.metodo || pago.id || pago.methodId || 0),
        amount: Number(pago.amount || pago.monto || pago.montorecibido || 0)
      };
    }).filter(pm => pm.paymentMethodId > 0 && pm.amount >= 0);

    // Validar que haya al menos un método de pago válido
    if (!paymentMethods.length) {
      this.loading = false;
      this.openSnackBar('No hay formas de pago válidas procesadas. Verifique los datos ingresados.', 'Error');
      if (this.dialogRefLoading) {
        this.dialogRefLoading.close();
      }
      return;
    }

    // Construir el voucher solo si corresponde (venta)
    let voucher: any = undefined;
    if (this.cajaService.articulosList && this.cajaService.articulosList.length > 0) {
      // Header simplificado según el formato requerido
      const today = new Date();
      const day = ('0' + today.getDate()).slice(-2);
      const month = ('0' + (today.getMonth() + 1)).slice(-2);
      const year = today.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      // obtengo el punto de venta y el número del comprobante
      const talonarioAsociado = this.cajaActual?.receiptBook;
      const header:Header = {
        number: Number(talonarioAsociado?.currentNumber) || 1,
        dateFrom: formattedDate,
        dateTo: formattedDate,
        expirationDate: formattedDate,
        receptorCuit: this.unCliente.documentNumber,
        receiptBookId: Number(talonarioAsociado.id),
        priceListId: this.listaPrecio, // Agregar priceListId al header
      };
      
      // Details simplificados según el formato requerido
      const details = this.cajaService.articulosList.map(art => ({
        id: art.id || 1,
        variantId: Number(art.variantId) || 0,
        quantity: Number(art.quantity) || 0,
        unitPrice: Number(art.unitPrice) || 0
      })).filter(d => d.quantity > 0 && d.unitPrice >= 0);
      
      voucher = {
        currencyId: 57, // Moneda por defecto (Pesos)
        voucherTypeId: Number(this.typeComprobante?.id) || 1, // Tipo de comprobante
        conceptId: Number(this.concepto?.id) || 1, // Concepto
        clientId: Number(this.unCliente?.id) || 1, // Cliente
        header,
        details
      };
    }

    // Construir el objeto según el formato requerido
    const cashOperationDto = {
      amount: Number(this.total) || 0,
      cashOperationTypeId: 1, // Tipo de operación (1 para venta)
      type: 'Entrada', // Cambiar a 'entrada' según el formato requerido
      cashSessionId: Number(this.cashBoxSession?.id || this.cajaActual?.id) || 0,
      paymentMethods,
      ...(this.observaciones && { description: this.observaciones }),
      ...(voucher && { voucher })
    };

    // Enviar datos al backend
    this.cajaService.guardarOperacionCaja(cashOperationDto).subscribe(
      (data) => {
        if (this.dialogRefLoading) {
          this.dialogRefLoading.close();
          this.dialogRefLoading = null;
        }
        
        // Preparar datos para el diálogo de confirmación y ticket
        const ventaData = this.prepararDatosVenta(data);
        
        // Mostrar diálogo de confirmación con opción de impresión
        this.mostrarDialogoConfirmacion(ventaData);
        
        // Limpiar formulario después de la venta exitosa
        this.cancelar();
      },
      (err) => {
        if (this.dialogRefLoading) {
          this.dialogRefLoading.close();
          this.dialogRefLoading = null;
        }
        this.loading = false;
        this.openSnackBar('Ocurrió un error al generar la venta', 'Error');
      }
    );
  }

  calcularTotal() {
    this.total = 0;
    for (
      let index = 0;
      index < this.cajaService.articulosList.length;
      index++
    ) {
      const art = this.cajaService.articulosList[index];
      const subtotal = art.subtotal;
      this.total = this.formatearPrecios(this.total + subtotal);
    }
    this.cantidad = 0;
    this.limpiarCamposNuevoArticulo();
  }

  formatearPrecios(valor: number) {
    let numeroFormateado = 0;
    if (valor > 0) {
      const precioString = valor.toString();
      const indice = precioString.indexOf('.');
      if (indice !== -1) {
        // existe punto
        const calculo = precioString.length - indice - 1;
        if (calculo >= 2) {
          numeroFormateado = Number.parseFloat(
            precioString.substring(0, indice + 3)
          );
        } else {
          numeroFormateado = Number.parseFloat(`${precioString}.00`);
        }
      } else {
        numeroFormateado = Number.parseFloat(`${precioString}.00`);
      }
    } else {
      numeroFormateado = valor;
    }
    return numeroFormateado;
  }

  eliminar(i) {
    const index = this.cajaService.articulosList.findIndex(x => x.id == i.id);
    if (index !== -1) {
      // eliminamos el item
      this.cajaService.articulosList.splice(index, 1);
      this.calcularTotal();
      this.openSnackBar('Registro eliminado', 'Información');
    }
  }

  setFocusCantidad() {
    this.cantidadElement.nativeElement.focus();
  }

  setFocusCliente() {
    this.clienteElement.nativeElement.focus();
  }

  setFocusArticulo() {
    // Solo enfocar si la caja está abierta y el elemento existe
    if (this.isCajaOpen && this.articuloElement && this.articuloElement.nativeElement) {
      this.articuloElement.nativeElement.focus();
    }
  }

  cancelarVenta() {
    Swal.fire({
      title: '¿Seguro que desea cancelar la venta?',
      text: 'Se perderan los cambios cargados hasta el momento!',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, quiero cancelar!',
    }).then((result) => {
      if (result.value) {
        this.cancelar();
        Swal.fire('Cancelado!', 'Su venta ha sido cancelada.', 'success');
      }
    });
  }

  cancelar() {
    this.lstarticulos = [];
    this.total = 0;
    // No establecer unCliente a null, sino resetear al cliente por defecto
    this.getClienteById(1);
    this.verInputBuscarCliente = false;
    this.verBtnBuscarCliente = false;
    this.verInputArticulo = true;
    this.verBtnBuscarArticulo = true;
    this.verBtnConfirmar = true;
    this.verBtnFPago = true;
    this.clienteSel = undefined;
    this.cambio = 0;
    this.montoing = 0;
    this.total = 0;
    this.lstPagos = [];
    this.lstDetalles = [];
    this.observaciones = '';
    this.listaFormularioImprimir = [];
    this.cajaService.eliminarListaArticulos();
    this.limpiarCamposNuevoArticulo();
    this.loading = false;
    
    // Solo cerrar el diálogo si existe
    if (this.dialogRefLoading) {
      this.dialogRefLoading.close();
      this.dialogRefLoading = null;
    }
    
    // Resetear el formulario a valores por defecto
    this.form.controls.clienteSel.setValue('Consumidor Final', {
      onlySelf: true,
    });
  }

  abrirEgresoEfectivo() {
    if (!this.cajaActual) {
      Swal.fire(
        'Atención!',
        'Debe abrir la caja para poder continuar.',
        'warning'
      );
      return;
    }
    
    // Navegar al componente de egreso con el cashSessionId como parámetro
    this.router.navigate(['/caja/egreso', this.cashBoxSession?.id]);
  }

  /**
   * Procesa una devolución desde el módulo de caja
   */
  procesarDevolucion() {
    if (!this.cajaActual) {
      Swal.fire(
        'Atención!',
        'Debe abrir la caja para poder continuar.',
        'warning'
      );
      return;
    }
    
    // Abrir diálogo para procesar devoluciones
    const dialogRef = this.dialog.open(ProcesarDevolucionComponent, {
      width: '1000px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: false,
      data: {
        cajaActual: this.cajaActual,
        cashBoxSession: this.cashBoxSession
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.processed) {
        // Mensaje mejorado con información del medio de pago
        const paymentInfo = result.paymentMethod ? 
          `<p>Método de reembolso: <strong>${result.paymentMethod.name}</strong></p>` : '';
        
        const warningInfo = result.cashOperationError ? 
          '<p class="text-warning"><small>⚠️ Hubo un problema al registrar el movimiento en caja</small></p>' : '';
        
        Swal.fire({
          title: 'Devolución Procesada',
          html: `
            <div class="text-left">
              <p>Se ha procesado exitosamente la devolución <strong>${result.return.returnNumber}</strong></p>
              <p>Monto reembolsado: <strong>$${result.amount.toFixed(2)}</strong></p>
              ${paymentInfo}
              <p>Se ha actualizado el inventario correspondiente.</p>
              ${warningInfo}
            </div>
          `,
          icon: 'success',
          confirmButtonText: 'Aceptar',
          customClass: {
            htmlContainer: 'text-left'
          }
        });
        
        // Actualizar los datos de la pantalla
        this.actualizarDatosPantalla();
      } else if (result && result.needsOpenCash) {
        // El usuario necesita abrir la caja
        this.abrirCajaManualmente();
      }
    });
  }

  /**
   * Método público para abrir la caja manualmente
   * Se puede llamar desde el template cuando el usuario hace clic en el botón "Abrir Caja"
   */
  abrirCajaManualmente(): void {
    this.cajaDialogShown = false; // Resetear flag
    this.openDialogAperturaCaja();
  }

  /*
    Busca un artículo primero por código de barras, luego por código normal
  */
  buscarArticuloPorCodigoBarras(codigo: string) {
    if (codigo !== '') {
      this.searchingProduct = true;
      // Primero intentar buscar por código de barras
      this.articuloService.getArticuloBycodeBarras(codigo).subscribe(
        (data) => {
          if (data && data.article) {
            // Encontrado por código de barras
            this.searchingProduct = false;
            this.procesarArticuloEncontrado(data.article);
          } else {
            // Si no se encuentra por código de barras, buscar por código normal
            this.buscarArticuloSinLimpiar(codigo);
          }
        },
        (err) => {
          // Error manejado silenciosamente - fallback a búsqueda por código normal
          this.buscarArticuloSinLimpiar(codigo);
        }
      );
    }
  }

  /*
    Procesa un artículo encontrado (común para ambos tipos de búsqueda)
  */
  procesarArticuloEncontrado(articulo: any) {
    if (this.comprobarArticuloCargado(articulo.id)) {
      const index = this.comprobarIndiceArticuloCargado(articulo.id);
      this.cajaService.articulosList[index].quantity += 1;
      let subt = 0;
      const cantidadXPrecio = (articulo.salePrice * this.cajaService.articulosList[index].quantity);
      const bonif = (this.unCliente.bonificacionValue * cantidadXPrecio) / 100;
      subt = (cantidadXPrecio - bonif);
      this.cajaService.articulosList[index].subtotalWithIva = subt;
      this.cajaService.articulosList[index].subtotal = subt;
    } else {
      let subt = 0;
      const bonif = (this.unCliente.bonificacionValue * articulo.salePrice) / 100;
      subt = (articulo.salePrice - bonif);
      const unidadesConversion = this.getUnidadesConversion(articulo);
      this.cajaService.addArticulo({
        id: articulo.id,
        code: articulo.code,
        description: articulo.name,
        type: articulo.type || 'Producto',
        unitPrice: articulo.salePrice,
        quantity: 1,
        bonus: this.unCliente.bonificacionValue,
        bonusAmount: 0,
        subtotal: subt,
        subtotalWithIva: subt,
        measurementUnitId: articulo.measurementUnitId || 52,
        conversionUnits: unidadesConversion,
        conversionUnitId: unidadesConversion[0]?.id || 0,
        batch: '',
        variantId: articulo.id,
        voucherId: 0
      });
    }
    this.calcularTotal();
    // Limpiar el campo de búsqueda y enfocar nuevamente
    this.limpiarCamposNuevoArticulo();
  }

  // Función helper para obtener unidades de conversión
  getUnidadesConversion(articulo: any) {
    if (articulo.conversionUnits && articulo.conversionUnits.length > 0) {
      return articulo.conversionUnits;
    } else {
      // Crear una unidad de conversión por defecto
      const conversionUnit = {
        id: articulo.measurementUnitId || 52,
        name: articulo.measurementUnitName || 'UNIDAD',
        quantity: 1,
        description: "",
        price: articulo.salePrice || 0,
        baseMeasurementUnit: {
          id: articulo.baseMeasurementUnitId || 0,
          code: articulo.baseMeasurementUnitCode || '',
          name: articulo.baseMeasurementUnitName || 'UNIDAD'
        },
        measurementUnit: {
          id: articulo.measurementUnitId || 52,
          code: articulo.measurementUnitCode || '',
          name: articulo.measurementUnitName || 'UNIDAD'
        }
      };
      return [conversionUnit];
    }
  }

  /*
    Busca un artículo por código normal sin limpiar automáticamente el campo
  */
  buscarArticuloSinLimpiar(idarticulo: string) {
    if (idarticulo !== '') {
      // Si searchingProduct ya está en true, no lo cambiamos
      if (!this.searchingProduct) {
        this.searchingProduct = true;
      }
      
      // obtengo el articulo
      this.articuloService.getArticuloPorcode(idarticulo).subscribe(
        (data) => {
          this.searchingProduct = false;
          const articulo = data as Producto;
          this.procesarArticuloEncontrado(articulo);
        },
        (err) => {
          this.searchingProduct = false;
          this.openSnackBar('No se encontró ningún producto con el código ingresado', 'Información');
          // Solo limpiar el campo cuando no se encuentra el producto
          this.limpiarCamposNuevoArticulo();
        }
      );
    }
  }

  /**
   * Actualiza datos sin resetear el flag del diálogo - para cambios de visibilidad
   */
  actualizarDatosSinDialog(): void {
    // Recargar el estado de la caja sin resetear flag de diálogo
    this.isCajaAbierta();
    
    // Recargar listas y datos necesarios
    this.getListaPrecios();
    this.getMonedas();
  }

  /**
   * Actualiza todos los datos de la pantalla después de apertura o cierre de caja
   * Recarga la información del estado de la caja y configura la interfaz
   */
  actualizarDatosPantalla(): void {
    // Resetear flag del diálogo solo cuando es necesario (apertura/cierre manual)
    this.cajaDialogShown = false;
    
    // Recargar el estado de la caja
    this.isCajaAbierta();
    
    // Recargar listas y datos necesarios
    this.getListaPrecios();
    this.getMonedas();
    
    // Limpiar artículos de la caja si los hay
    this.cajaService.eliminarListaArticulos();
    
    // Resetear total
    this.total = 0.0;
    
    // Resetear cliente a consumidor final
    this.cliente = 'Consumidor Final';
    this.form.controls.clienteSel.setValue(this.cliente, {
      onlySelf: true,
    });
    this.getClienteById(1);
    
    // Limpiar observaciones
    this.form.controls.observaciones.setValue('', {
      onlySelf: true,
    });
    
    // Solo enfocar el input de artículo si la caja está abierta
    if (this.isCajaOpen) {
      setTimeout(() => {
        this.setFocusArticulo();
      }, 100);
    }
  }

  /**
   * Prepara los datos de la venta para el diálogo de confirmación y ticket
   * @param responseData Respuesta del servidor después de guardar la venta
   * @returns Objeto con datos formateados para mostrar y imprimir
   */
  prepararDatosVenta(responseData: any): any {
    // Obtener fecha y hora actual
    const fechaActual = new Date();
    const fecha = fechaActual.toLocaleDateString('es-AR');
    const hora = fechaActual.toLocaleTimeString('es-AR', { hour12: false });

    // Preparar datos de productos vendidos
    const productos = this.cajaService.articulosList?.map(articulo => ({
      id: articulo.id,
      code: articulo.code,
      description: articulo.description,
      quantity: articulo.quantity,
      unitPrice: articulo.unitPrice,
      subtotalWithIva: articulo.subtotalWithIva || (articulo.quantity * articulo.unitPrice),
      bonus: articulo.bonus || 0
    })) || [];

    // Preparar datos de formas de pago
    const formasPago = this.lstPagos?.map(pago => ({
      descripcion: pago.formaPago?.name || pago.descripcion || 'Efectivo',
      monto: pago.montorecibido || pago.amount || pago.monto || 0
    })) || [];

    // Generar número de comprobante si está disponible
    let numeroComprobante = null;
    if (responseData?.voucher?.header?.number) {
      const puntoVenta = this.talonario ? String(this.talonario).padStart(4, '0') : '0001';
      const numero = String(responseData.voucher.header.number).padStart(8, '0');
      numeroComprobante = `${puntoVenta}-${numero}`;
    }

    return {
      cliente: this.unCliente?.companyName || this.cliente || 'Consumidor Final',
      vendedor: this.cajero || 'N/A',
      puntoVenta: this.talonario || 'N/A',
      numeroComprobante: numeroComprobante,
      fecha: `${fecha} ${hora}`,
      total: this.total || 0,
      productos: productos,
      formasPago: formasPago,
      observaciones: this.observaciones || this.form.get('observaciones')?.value || null,
      responseData: responseData // Datos originales de respuesta por si se necesitan
    };
  }

  /**
   * Muestra el diálogo de confirmación de venta con opción de impresión
   * @param ventaData Datos de la venta para mostrar
   */
  mostrarDialogoConfirmacion(ventaData: any): void {
    this.dialogRefConfirmacion = this.dialog.open(ConfirmacionVentaComponent, {
      width: '600px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      data: {
        ventaData: ventaData
      },
      disableClose: false,
      autoFocus: true,
      panelClass: 'confirmacion-venta-dialog'
    });

    this.dialogRefConfirmacion.afterClosed().subscribe((imprimio: boolean) => {
      // El diálogo devuelve true si se imprimió, false si solo se cerró
      if (imprimio) {
        // Opcional: mostrar mensaje de confirmación de impresión
        this.openSnackBar('Ticket enviado a impresión', 'Éxito');
      }
      
      // Limpiar referencia del diálogo
      this.dialogRefConfirmacion = null;
    });
  }

}
